import React from "react";
import "../assets/css/style.css";
import logo from "../assets/img/logo.png";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        
        {/* Logo & Description */}
        <div className="footer-section">
          <a href="/" className="flex items-center gap-1">
            <img src={logo} alt="Logo" className="h-8" />
          </a>
          <p className="footer-desc">
            Build polished, ATS-ready resumes in minutes. Easy, effective, and
            trusted by thousands of job seekers.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="/homescreen">Templates</a></li>
            <li><a href="#faq">FAQs</a></li>
            <li><a href="/contact_us">Support</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3 className="footer-heading">Contact Us</h3>
          <p>
            <b>Email:</b>{" "}
            <a href="mailto:support@sample.com">support@sample.com</a>
          </p>
          <p>
            <b>Phone:</b> +91 9999999999
          </p>
        </div>

        {/* Social Media */}
        <div className="footer-section">
          <h3 className="footer-heading">Follow Us</h3>
          <div className="footer-social">
            <a href="#" aria-label="LinkedIn">
              <i className="fa-brands fa-linkedin"></i>
            </a>
            <a href="#" aria-label="Twitter">
              <i className="fa-brands fa-x-twitter"></i>
            </a>
            <a href="#" aria-label="Facebook">
              <i className="fa-brands fa-facebook"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Resume Snap. All rights reserved by{" "}
        <a target="_blank" href="https://www.cognosparkinnovations.com/index.html">
          Cognospark Innovations
        </a>.
      </div>
    </footer>
  );
}
